<div class="baseContainer container-fluid twoScreenPageWrapper">
	<div class="headerAndActionRow row">
		<div class="col-12 headerAndActionRowContent">
			<div class="titleWithIcon">
				@if (backRoute()) {
					<button
						(click)="navigateBack()"
						class="backButton"
						[matTooltip]="T.BUTTON_GO_BACK | translate"
						color="accent"
						mat-icon-button
						matTooltipClass="accent"
					>
						<mat-icon fontIcon="fa-arrow-left" fontSet="fad" inline />
					</button>
				}

				<div class="icon">
					<i class="fa-2x {{ headerIcon.fontSet }} {{ headerIcon.fontIcon }}"></i>
				</div>

				<div class="title">
					<h1 class="mat-h1 nomargin">{{ translatedHeader }}</h1>
				</div>
			</div>

			<div class="adminSettingsPageActionCon">
				<sim-table-column-search
					(searchFilterValueChange)="handleSearchFilterValueChange($event)"
					[(searchFilterColumn)]="searchFilterColumn"
					[isShowing]="filterFieldShowing"
					[searchFilterValue]="searchFilterValue"
					[searchableColumns]="searchableColumns"
				/>

				@if (actionConfig?.isSearchable !== "false") {
					<button
						(click)="openFilterField()"
						[appBusy]="busyPromises"
						[disabled]="actionConfig?.isSearchable === 'disabled'"
						class="searchButton"
						color="accent"
						mat-icon-button
					>
						<sim-animated-material-icon
							[endIcon]="{
								fontSet: 'fad',
								fontIcon: 'fa-times',
								themeColor: 'warn',
							}"
							[startIcon]="{
								fontSet: 'fad',
								fontIcon: 'fa-search',
								themeColor: 'accent',
							}"
							[trigger]="filterFieldShowing"
						/>
					</button>
				}

				<button class="large" color="accent" mat-icon-button (click)="resetColumns()">
					<mat-icon fontIcon="fa-undo" fontSet="far" inline />
				</button>
				<mat-form-field class="columnDropdown" color="accent" subscriptSizing="dynamic">
					<mat-label>{{ T.CONFIGURATION_EDITOR_SELECT_COLS | translate }}</mat-label>
					<mat-select [formControl]="columnCtrl" multiple panelWidth="">
						<mat-select-trigger>
							@if (columnCtrl.value.length + defaultColumns.length === displayedColumns.length) {
								<span> {{ T.CONFIGURATION_EDITOR_ALL_COLS | translate }} </span>
							} @else {
								<span> {{ columnCtrl.value?.length || 0 }} </span>
							}
						</mat-select-trigger>
						@for (column of displayedColumns; track column) {
							@if (!["select", "actions"].includes(column)) {
								<mat-option [value]="column">
									{{ column }}
								</mat-option>
							}
						}
					</mat-select>
				</mat-form-field>

				<div class="adminSettingsPageAction">
					@if (actionConfig.isEditable !== "false" && !actionConfig.hideEditAll) {
						<sim-button
							(onClick)="editAllClicked()"
							[animation]="{
								icon: {fontSet: 'fad', fontIcon: 'fa-check'},
								trigger: editAllActive,
							}"
							[appBusy]="busyPromises"
							[icon]="{fontSet: 'fad', fontIcon: 'fa-edit'}"
							[label]="editAllActive ? T.CONFIGURATION_EDITOR_SAVE_ALL : T.CONFIGURATION_EDITOR_EDIT_ALL"
							color="accent"
						/>
					}
				</div>

				<div class="adminSettingsPageAction">
					@if (actionConfig.supportMultiCreate === true && !actionConfig.hideCreate) {
						<button
							[appBusy]="busyPromises"
							[matMenuTriggerFor]="createMultiDropDown"
							class="createButton"
							color="accent"
							mat-fab
						>
							<ng-container>
								<mat-icon fontIcon="fa-plus" fontSet="fas" inline />
							</ng-container>
						</button>
						<mat-menu #createMultiDropDown="matMenu">
							<button (click)="creatElementClicked()" class="menueButtonWithFAIcon" mat-menu-item>
								<mat-icon fontIcon="fa-plus" fontSet="fas" />
								<span>{{ T.CONFIGURATION_EDITOR_CREATE_SINGLE_ITEM | translate }}</span>
							</button>
							<button (click)="createMultiElement()" class="menueButtonWithFAIcon" mat-menu-item>
								<mat-icon fontIcon="fa-layer-plus" fontSet="fad" />
								<span>{{ T.CONFIGURATION_EDITOR_CREATE_MULTIPLE_ITEMS | translate }}</span>
							</button>
						</mat-menu>
					}

					@if (actionConfig.supportMultiCreate === false && !actionConfig.hideCreate) {
						<button (click)="creatElementClicked()" class="createButton" color="accent" mat-fab>
							<mat-icon fontIcon="fa-plus" fontSet="fas" inline />
						</button>
					}
				</div>

				@if (hasAdditionalActions) {
					<div class="adminSettingsPageAction additionalActions">
						<button [matMenuTriggerFor]="additionalActionsMenue" class="large" color="accent" mat-icon-button>
							<mat-icon fontIcon="fa-chevron-down" fontSet="far" inline />
						</button>
						<mat-menu #additionalActionsMenue="matMenu">
							<ng-content select="[additionalActions]" />
						</mat-menu>
					</div>
				}
			</div>
		</div>

		<div class="col-12">
			<mat-divider class="headerDivider" />
		</div>
	</div>

	<div [class.marginForContent]="refAdditionalContent.children.length" class="row additionalContentTopOfTable">
		<div #refAdditionalContent class="col-12">
			<ng-content select="[additionalContentTopOfTable]" />
		</div>
	</div>

	<div class="contentTableRow row">
		<div class="col-12 exampleTableContainerWrapper">
			<div class="exampleTableContainer mat-elevation-z8" id="contentTableHolder">
				<sim-component-loading-container
					[isLoading]="isLoadingResults"
					[loadingIcon]="'fad ' + titleIcon"
					[loadingMessage]="T.GENERAL_TXT_LOADING | translate: {loadingParam: title}"
					[showBackDrop]="true"
				/>

				<mat-table
					(cdkDropListDropped)="dropTable($event)"
					[cdkDropListDisabled]="!changeOrders"
					[class.loadingData]="isLoadingResults"
					[dataSource]="dataSource"
					[trackBy]="TrackByMethods.trackByIndex"
					cdkDropList
					class="contentTable"
					multiTemplateDataRows
				>
					<!-- Checkbox Column -->
					@if (selection) {
						<ng-container matColumnDef="select">
							<mat-header-cell *matHeaderCellDef class="textAlignCenter specialCell specialCellCheckbox" mat-header-cell>
								<mat-checkbox
									(change)="$event ? masterToggle() : null"
									[checked]="selection.hasValue() && isAllSelected()"
									[indeterminate]="selection.hasValue() && !isAllSelected()"
								/>
							</mat-header-cell>
							<mat-cell *matCellDef="let row" class="textAlignCenter specialCell specialCellCheckbox" mat-cell>
								<mat-checkbox
									(change)="$event ? selection.toggle(row) : null"
									[checked]="selection.isSelected(row)"
									appStopPropagation
								/>
							</mat-cell>
						</ng-container>
					}

					<ng-content select="[tableColumns]" />

					<ng-container matColumnDef="actions">
						<mat-header-cell *matHeaderCellDef class="actionsCell" mat-header-cell />

						<mat-cell
							(dblclick)="$event.stopPropagation()"
							*matCellDef="let element; let i = renderIndex"
							class="actionsCell"
							mat-cell
						>
							<div appStopPropagation class="actionsWrapper">
								<ng-template
									[ngTemplateOutletContext]="{
										$implicit: element,
									}"
									[ngTemplateOutlet]="additionalActionsTemplateRef"
								/>

								<!-- TODO: Hide divider if no additional actions are provided -->
								@if (
									actionConfig.isDeletable !== "false" ||
									actionConfig.isEditable !== "false" ||
									actionConfig.isDuplicatable !== "false" ||
									actionConfig.isJSONViewable !== "false"
								) {
									<mat-divider [vertical]="true" />
								}

								@if (actionConfig.isJSONViewable !== "false") {
									<button
										(click)="openJSONViewDialog(element)"
										[disabled]="
											actionConfig?.isJSONViewable === 'disabled' || currentEditElement === element || editAllActive
										"
										color="accent"
										mat-icon-button
										matTooltip="{{ T.JSON_VIEW_DIALOG_TITLE | translate }}"
										matTooltipClass="accent"
									>
										<mat-icon fontIcon="fa-eye" fontSet="fad" inline />
									</button>
								}

								@if (actionConfig.isEditable !== "false") {
									<button
										(click)="editToggleClicked(element)"
										[appBusy]="busyPromises"
										[disabled]="actionConfig?.isEditable === 'disabled' || editAllActive"
										[matTooltip]="
											(currentEditElement === element
												? T.SHARED_BASIC_ADMINISTRATION_TABLE_SAVE
												: T.SHARED_BASIC_ADMINISTRATION_TABLE_EDIT
											) | translate
										"
										color="accent"
										mat-icon-button
										matTooltipClass="accent"
									>
										<sim-animated-material-icon
											[endIcon]="{
												fontSet: 'fad',
												fontIcon: 'fa-check',
											}"
											[startIcon]="{
												fontSet: 'fad',
												fontIcon: 'fa-edit',
												themeColor: 'accent',
											}"
											[trigger]="currentEditElement === element"
										/>
									</button>
								}

								@if (!element.isDraft && actionConfig.isDuplicatable !== "false") {
									<button
										(click)="duplicateItemClickedEmitter.emit(element)"
										[appBusy]="busyPromises"
										[disabled]="
											actionConfig?.isDuplicatable === 'disabled' || currentEditElement !== null || editAllActive
										"
										color="accent"
										mat-icon-button
										matTooltip="{{ T.GENERAL_TXT_DUPLICATE_ENTRY | translate }}"
										matTooltipClass="accent"
									>
										<mat-icon fontIcon="fa-clone" fontSet="fad" inline />
									</button>
								}

								@if (element.isDraft) {
									<button
										(click)="removeDraftItemClicked.emit()"
										[matTooltip]="T.SHARED_BASIC_ADMINISTRATION_TABLE_REMOVE_DRAFT_ITEM | translate"
										color="warn"
										mat-icon-button
										matTooltipClass="accent"
									>
										<mat-icon fontIcon="fa-times" fontSet="fad" inline />
									</button>
								}

								@if (actionConfig?.isDeletable !== "false") {
									<button
										(click)="deleteElementClicked(element)"
										[disabled]="
											actionConfig?.isDeletable === 'disabled' || currentEditElement !== null || editAllActive
										"
										[matTooltip]="deleteElementText ?? T.GENERAL_TXT_REMOVE_ENTRY | translate"
										color="warn"
										mat-icon-button
										matTooltipClass="warn"
									>
										<mat-icon fontIcon="fa-trash-alt" fontSet="fad" inline />
									</button>
								}

								@if (enableExpandElement) {
									<button (click)="notifyExpandedElementChanged(element, i)" color="accent" mat-icon-button>
										<sim-animated-material-icon
											[endIcon]="{
												fontSet: 'fad',
												fontIcon: 'fa-chevron-down',
											}"
											[startIcon]="{
												fontSet: 'fad',
												fontIcon: 'fa-chevron-up',
												themeColor: 'accent',
											}"
											[trigger]="expandedElementIndex === i"
										/>
									</button>
								}
							</div>
						</mat-cell>
					</ng-container>

					<mat-header-row *matHeaderRowDef="filteredColumns; sticky: true" />
					<mat-row
						(click)="notifyExpandedElementChanged(element, i)"
						(dblclick)="
							actionConfig.isEditable !== 'false' && currentEditElement !== element && !editAllActive
								? editToggleClicked(element)
								: ''
						"
						*matRowDef="let element; let i = renderIndex; columns: filteredColumns"
						[class.example-expanded-row]="expandedElement === element"
						[class.isNewlyCreated]="element.isDraft"
						cdkDrag
						class="example-element-row {{ getClassForSpecificRow(element) }}"
						mat-ripple
						mat-row
					/>
					<mat-row
						*matRowDef="let row; columns: enableExpandElement ? ['expandedDetail'] : []"
						class="example-detail-row"
						mat-row
					/>
				</mat-table>

				@if (dataSource?.length <= 0 && !isLoadingResults) {
					<div class="noElementsQueriedContainer">
						<div class="icon">
							<i class="fad {{ titleIcon }} fa-3x"></i>
						</div>
						<div class="text mat-h2 nomargin">
							{{ T.BASE_ADMINISTRATION_TABLE_NO_ELEMENT_FOUND | translate: {title: title ?? "Element"} }}
						</div>
					</div>
				}
			</div>

			<div class="matPaginatorContainer">
				@if (selection) {
					<div [class.showing]="!selection.isEmpty()" class="bulkActionContainer">
						<div class="descriptionForBulkOperationContainer">
							<mat-icon class="descriptionIcon" fontIcon="fa-tasks" fontSet="fad" inline />
							{{ T.SHARED_BASIC_ADMINISTRATION_TABLE_CHECKED_ITEM | translate }}
						</div>
						<mat-form-field color="accent">
							<mat-label>{{ T.SHARED_BASIC_ADMINISTRATION_TABLE_BULK_ACTION | translate }}</mat-label>
							<mat-select [(ngModel)]="selectedBulkAction">
								@for (bulkAction of bulkActions; track bulkAction) {
									<mat-option [value]="bulkAction">
										{{ bulkAction.displayNameTranslationKey | translate }}
									</mat-option>
								}
								<mat-option [value]="undefined">
									{{ T.SHARED_BASIC_ADMINISTRATION_TABLE_NO_ACTION | translate }}
								</mat-option>
							</mat-select>
						</mat-form-field>
						@if (selectedBulkAction) {
							<button
								(click)="executeBulkAction()"
								[@zoomInOnEnter]
								[@zoomOutOnLeave]
								class="executeBulkAction"
								color="accent"
								mat-flat-button
							>
								{{ T.SHARED_BASIC_ADMINISTRATION_TABLE_EXECUTE | translate }}
								<mat-icon fontIcon="fa-check-double" fontSet="fad" inline />
							</button>
						}
					</div>
				}

				<mat-paginator
					[length]="resultsLength"
					[pageIndex]="currentPageIndex"
					[pageSizeOptions]="[10, 25, 100]"
					[pageSize]="currentPageSize"
					[style]="enablePagination ? '' : 'display: none;'"
					class="basic-admin-mat-paginator"
					showFirstLastButtons="true"
				/>
			</div>
		</div>
	</div>
</div>
